// extracted by mini-css-extract-plugin
module.exports = {"root":"TypeName_root__1c8V2","strikethrough":"TypeName_strikethrough__1hkuH"};